<template>
  <div class="app-page scroll">
    <div class="main">
      <h1>Contact us</h1>

        

      <div class="left">
        <ContactFormLanding />
      </div>
    </div>
  </div>
</template>

<script setup>
import ContactFormLanding from '@/components/ContactFormLanding.vue';
import { useRouter } from 'vue-router';
import {ref} from 'vue';
const router = useRouter();

const  planTerms =ref([
  { value: 'short', display: "Monthly" },
  { value: 'year', display: "Save by choosing annual plan" },
]);
const planTerm = ref("year");

function planClickedHandler(v) {
  if  (v.name.includes("custom")) 
  {
    router.push({
      path: "/",
      hash: "#contact"
    });
    return;
  }

  router.push({ path: '/signup' });
}

</script>

<style lang="scss" scoped>
.main {
  margin: 30px;
  background: white;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 10px;
  height: fit-content;
  width: fit-content;
}
.app-page {
  align-items: center;
  text-align: center;
  overflow: visible;
  height: 100dvh;
  background-color: #250e81 !important;
  background-image: url("@/assets/img/blu-stripes.png") !important;
}

.left {
  text-align: left;
}

@media (max-width: $breakpoint-sm) {
  .signup {
    padding: 8px;
  }
}
@media (max-width: $breakpoint-md) {
  .signup {
    padding: 16px;
  }
}

.top-msg {
  margin: 20px;
}

.scroll {
  overflow-y: scroll;
}

</style>
